module.exports = __webpack_public_path__ + "img/big7-2.b65b5a4c.jpg";